import { ReactNode, ComponentType } from 'react';
import { cx } from '@linaria/atomic';
import { Heading } from '../../heading/heading.component';
import { trayHeader, trayHeaderButtons, trayHeaderTitle } from './tray.styles';

type TrayHeaderProps = {
  children?: ReactNode;
  Buttons?: ReactNode;
  className?: string;
  Button?: ComponentType<React.PropsWithChildren<unknown>>;
};

const Title = (props) => <Heading level={2} className={trayHeaderTitle} {...props} />;

export const TrayHeader = ({ Buttons, children, Button, className, ...rest }: TrayHeaderProps) => {
  return (
    <section className={cx(trayHeader, 'tray-header', className)} {...rest}>
      {typeof children === 'string' ? <Title>{children}</Title> : children}
      <div className={trayHeaderButtons}>{Buttons}</div>
    </section>
  );
};
